<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Joshua Whittaker was born in the West Midlands, England. From a young age, he was a fan of sci-fi, fantasy books and movies. Later, he also developed an interest in horror. The author identifies himself as bisexual.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5c5a0f12